import { Inject, Pipe, PipeTransform } from '@angular/core';
import { BASE_OMS_URL } from 'src/app/injection-tokens';

@Pipe({
  name: 'omsCustomerLink',
})
export class OmsCustomerLinkPipe implements PipeTransform {
  constructor(@Inject(BASE_OMS_URL) readonly baseOMSUrl: string) {}

  transform(customerId: number): unknown {
    return `${this.baseOMSUrl}customer/${customerId.toString()}/10001`;
  }
}
